import { APP_ROUTES } from "const";
import { useVerifyOtpApi } from "hooks";
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "lib/supabaseClient";
import { FIELD_NAMES } from "./VerifyOtp.constants";

export function useEmailFromLocation() {
  const { state, search } = useLocation();
  return useMemo(() => {
    const stateEmail = (state as { email?: string } | null)?.email;
    if (stateEmail) return stateEmail;
    const query = new URLSearchParams(search);
    return query.get("email") || "";
  }, [state, search]);
}

export function useInitialState() {
  return useMemo(() => {
    return {
      [FIELD_NAMES.TOKEN]: "",
    };
  }, []);
}

export function useSubmitHandler(email: string) {
  const { mutateAsync } = useVerifyOtpApi({});
  const navigate = useNavigate();

  return useCallback(
    async (props, formikHelpers) => {
      try {
        const result = await mutateAsync({
          email: email.toLowerCase(),
          token: props.token,
        });

        const session = result?.data?.session;
        if (session?.access_token && session?.refresh_token) {
          await supabase.auth.setSession({
            access_token: session.access_token,
            refresh_token: session.refresh_token,
          });
          window.location.assign(`${APP_ROUTES.PROFILE}?welcome=true`);
          return;
        }

        // No session returned — fall back to sign-in screen
        navigate(APP_ROUTES.SIGN_IN);
      } catch (error: any) {
        const data = error?.response?.data || {};
        formikHelpers.setErrors({
          [FIELD_NAMES.TOKEN]:
            data.token || data.message || "Invalid or expired code",
        });
      }
    },
    [mutateAsync, navigate, email]
  );
}
